import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import { ProductTemplateService } from 'modules/inventory/settings/product-templates/services';
import { PRODUCT_TEMPLATE_ONE_KEY } from 'modules/inventory/settings/product-templates/constants';
import { IProductTemplate } from 'modules/inventory/settings/product-templates/interfaces';

export const useFindOneProductTemplate = (id: string | null) => {
  const fetch = useCallback(() => ProductTemplateService.getOne(id as string), [id]);
  return useQuery<IProductTemplate>([id, PRODUCT_TEMPLATE_ONE_KEY], fetch, { enabled: !!id });
};
